<template>
  <div>
    <div
      v-if="surfaceTotaleGraineSelected> 0 && !loading"
      class="d-flex justify-space-around"
      :class="$vuetify.breakpoint.mobile ? 'flex-column' : 'mt-4'"
    >
      <BaseDoughnutChartV2
        class="align-self-center my-4"
        :class="$vuetify.breakpoint.mobile ? 'flex-column' : 'mr-5'"
        :chart-data="chartDataAssolement"
      />
      <div
        class="align-self-center"
        :class="$vuetify.breakpoint.mobile ? 'my-4' : ''"
      >
        <div
          v-for="(culture, index) in culturesSelected"
          :key="index"
        >
          <div class="pt-2 texte texte-gris-fonce">
            <v-chip
              label
              :color="culture.couleur"
              class="eq-width mr-2"
            >
              <span class="white--text">{{ culture.pourcentage | roundNumber(0) }} %</span>
            </v-chip>
            {{ culture.type }}
          </div>
        </div>
      </div>
    </div>
    <v-divider
      v-if="surfaceTotaleGraineSelected> 0 && !loading"
      class="mb-2 mt-6"
    />
    <div
      v-if="surfaceTotaleGraineSelected> 0 && !loading"
      class="py-2 d-flex justify-space-between mt-6"
    >
      <div class="titre-h4 secondary--text align-self-center">
        Surface {{ libelleCulture }}
      </div>
      <div class="chiffre secondary--text align-self-center">
        {{ surfaceTotaleGraineSelected | roundNumber(0) }} ha
      </div>
    </div>
    <div
      v-if="surfaceTotaleGraineSelected === 0 && !loading"
    >
      <div
        class="d-flex
        align-center
        flex-column"
        :class="$vuetify.breakpoint.mobile ? 'mt-6' :'mt-16' "
      >
        <img
          src="@/assets/no-cultures.svg"
          alt="no-cultures"
        >
        <div
          class="intro texte-gris-fonce text-align-center mt-2"
          :class="$vuetify.breakpoint.mobile ? 'mb-6' :'mx-16' "
        >
          <span>Visualisez ici la surface totale en lien avec votre graine de commercialisation</span>
        </div>
      </div>
    </div>
    <BaseLoader v-if="loading" />
  </div>
</template>
<script>
import BaseDoughnutChartV2 from '@/components/chart/base-doughnut-chart-v2.vue'
import { capitalize, sum } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import BaseLoader from '@/components/common/base-loader.vue'
import {clone} from '@/utils/clone'

export default {
  name: 'Cultures',
  components: { BaseDoughnutChartV2, BaseLoader },
  data () {
    return {
      couleurs: ['#00713C', '#DBBD00', '#969A27', '#669D24', '#FF812B', '#EC6608', '#FFDD00'],
      loading: true
    }
  },

  computed: {
    ...mapGetters({
      assolement: 'assolement/assolement',
      grainesContractualiseesEtRecoltees: 'graine/grainesContractualiseesEtRecoltees',
      anneeRecolteActive: 'application/anneeRecolteActive',
      codeGraineActive: 'application/codeGraineActive'
    }),
    surfaceTotale () {
      return sum(this.assolement.flatMap(c => c.surfaceEnHectare))
    },
    libelleCulture () {
      return this.grainesContractualiseesEtRecoltees.find(g => g.code === this.codeGraineActive)!= null ? capitalize(this.grainesContractualiseesEtRecoltees.find(g => g.code === this.codeGraineActive).libelle) : ''
    },
    assolementSorted () {
      if (!this.loading) {
        let assolementModifiable = clone(this.assolement)
        assolementModifiable = assolementModifiable.sort((a, b) => {
        if (b.surfaceEnHectare >= a.surfaceEnHectare) {
          return -1
        }
        if (b.surfaceEnHectare <= a.surfaceEnHectare) {
          return 1
        }
        return 0
      })
      assolementModifiable = assolementModifiable.sort((a) => {
        if (a.codesRs3Correspondants.includes(this.codeGraineActive)) {
          return -1
        }
        else {
          return 1
        }
      })
      return assolementModifiable
      } else {
        return []
      }
      
    },
    culturesSelected () {
      let result = []
      for (let i = 0; i < this.assolementSorted.length; i++ ) {
        if (this.codeGraineActive !== null && this.assolementSorted[i].codesRs3Correspondants.includes(this.codeGraineActive)) {
          result.push({ type: this.assolementSorted[i].typeCulture, couleur: this.couleurs[i], pourcentage: this.assolementSorted[i].surfaceEnHectare / this.surfaceTotale * 100, surface: this.assolementSorted[i].surfaceEnHectare })
        }
      }
      return result
    },
    surfaceTotaleGraineSelected () {
      return sum(this.culturesSelected.flatMap(c => c.surface))
    },
    labelsAssolement () {
      return this.assolementSorted.map(a => a.typeCulture)
    },
    datasetAssolement () {
      return this.assolementSorted.map(a => a.surfaceEnHectare)
    },
    backgroundColor () {
      const backgroundColors = []
      for (let i = 0; i < this.assolementSorted.length; i++ ) {
        let couleur = this.couleurs[i]

        if (this.codeGraineActive !== null && !this.assolementSorted[i].codesRs3Correspondants.includes(this.codeGraineActive)) {
          couleur = '#F1F2F5'
        }
        backgroundColors.push(couleur)
      }
      return backgroundColors
    },
    chartDataAssolement () {
      return {
        id:'chartCultures',
        labels: this.labelsAssolement,
        datasets: [
          {
            backgroundColor: this.backgroundColor,
            data: this.datasetAssolement,
            legendTooltip: { title: 'surface', value: this.datasetAssolement.map(value => value.toFixed(2).replace(/\./g, ',')), unit: 'ha' },
            unite: 'ha'
          }
        ]
      }
    },
  },
  watch: {
    anneeRecolteActive: {
      handler (annee) {
        if (annee) {
          this.loadAssolement()
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions({
      getAssolement: 'assolement/getAssolement',
    }),
    loadAssolement () {
      this.getAssolement()
        .catch(() => {
          this.erreur = true
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped >
.eq-width {
  width: 58px;
}

.text-align-center {
  text-align: center;
}

</style>
